import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

export interface ComponentCanDeactivate {
  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean;
}

@Injectable()
export class PendingChangesGuard {
  /**
   * Guard to add a confirmation of unsaved changes on navigattion
   */
  canDeactivate(
    component: ComponentCanDeactivate
  ): Observable<boolean> | Promise<boolean> | boolean {
    return component?.canDeactivate ? component.canDeactivate() : true;
  }
}
